import React from "react";

function ManagedProfileTable({ users, onOpenModal }) {
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped align-middle text-center">
        <thead className="table-light">
          <tr>
            <th>帳號</th>
            <th>姓名</th>
            <th>生日</th>
            <th>姓別</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.userId}>
              <td>{u.account}</td>
              <td>{u.name}</td>
              <td>{u.birthday}</td>
              <td>{u.gender}</td>
              <td>
                <div>
                  {/* <button className="btn btn-outline-primary btn-sm me-1" onClick={() => handleEdit(r)}>編輯</button> */}
                  <button
                    className="btn btn-sm btn-warning"
                    onClick={() => onOpenModal("password", u)}
                  >
                    改密碼
                  </button>
                </div>
                <div>
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => onOpenModal("delete", u)}
                  >
                    註銷使用者
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ManagedProfileTable;
